/**
 * Format date to DD/MM/YYYY format
 * @param {Date|string} date - Date object or date string
 * @returns {string} Date in DD/MM/YYYY format
 */
export const formatDateToDDMMYYYY = (date) => {
  if (!date) return '';
  
  let dateObj;
  if (typeof date === 'string') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }
  
  if (isNaN(dateObj.getTime())) return '';
  
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Parse DD/MM/YYYY date string to Date object
 * @param {string} dateStr - Date string in DD/MM/YYYY format
 * @returns {Date|null} Date object or null if invalid
 */
export const parseDDMMYYYY = (dateStr) => {
  if (!dateStr) return null;
  
  const parts = dateStr.split('/');
  if (parts.length !== 3) return null;
  
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
  const year = parseInt(parts[2], 10);
  
  const date = new Date(year, month, day);
  
  // Validate the date
  if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
    return null;
  }
  
  return date;
};

/**
 * Format date to YYYY-MM-DD format (for input fields)
 * @param {Date|string} date - Date object or date string
 * @returns {string} Date in YYYY-MM-DD format
 */
export const formatDateToYYYYMMDD = (date) => {
  if (!date) return '';
  
  let dateObj;
  if (typeof date === 'string') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }
  
  if (isNaN(dateObj.getTime())) return '';
  
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Convert DD/MM/YYYY to YYYY-MM-DD (for comparisons and input fields)
 * @param {string} dateStr - Date string in DD/MM/YYYY format
 * @returns {string} Date in YYYY-MM-DD format
 */
export const convertDDMMYYYYToYYYYMMDD = (dateStr) => {
  if (!dateStr) return '';
  
  const parts = dateStr.split('/');
  if (parts.length !== 3) return '';
  
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

/**
 * Convert YYYY-MM-DD to DD/MM/YYYY
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Date in DD/MM/YYYY format
 */
export const convertYYYYMMDDToDDMMYYYY = (dateStr) => {
  if (!dateStr) return '';
  
  const parts = dateStr.split('-');
  if (parts.length !== 3) return '';
  
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};
